import React, { useState } from "react";
import SEO from "../components/SEO";
import HeroInner from "../components/HeroInner/HeroInner";
import Services from "../components/Services";
import ChatBot from "../components/ChatBot";
import GlobalScripts from "../components/GlobalScripts";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer";
import Tooltip from "../components/Tooltip";
import ContactModal from "../components/ContactModal/ContactModal"; // Modal integrado
import "./DesarrolloWeb.css";

function Optimizacion() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <SEO
        title="Optimización Web | Velocidad y SEO Técnico"
        description="Mejora la velocidad, rendimiento y SEO técnico de tu sitio web. Acelera tu carga y domina los Core Web Vitals de Google."
        url="https://juancarlosmancharamos.ar/optimizacion-web"
      />

      <Menu />

      <HeroInner
        title="Optimización Web"
        subtitle="Velocidad extrema, SEO técnico y rendimiento de alto nivel"
        bg="/assets/images/bg-dev.jpg"
      />

      <section className="container dev-section">
        <div className="dev-inner-wrap">
          
          {/* Encabezado y Texto Principal */}
          <div className="dev-header">
            <div className="dev-intro-content">
              <h2 className="dev-title">Haz que tu Web Vuele (y que Google la Ame)</h2>
              <p className="dev-lead">
                Un sitio lento no solo frustra a tus usuarios, sino que es penalizado duramente por Google. Aplico optimización técnica avanzada para llevar el rendimiento de tu web al límite de velocidad.
              </p>
              <p>
                A través de auditorías exhaustivas, soluciono cuellos de botella en servidores, optimizo bases de datos y ajusto el código para cumplir estrictamente con los <strong>Core Web Vitals</strong>. El resultado es un sitio ultra rápido que retiene visitantes, disminuye el porcentaje de rebote y mejora drásticamente su posicionamiento orgánico.
              </p>
            </div>
          </div>

          {/* Cuadrícula de Características con Iconos (Enfocados en Optimización) */}
          <div className="dev-features">
            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Velocímetro/Reloj (Velocidad) */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
              </div>
              <h3>WPO (Web Performance)</h3>
              <p>Reducción drástica del tiempo de carga. Optimización de imágenes (WebP/AVIF), minificación de CSS/JS y configuración avanzada de caché.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Checklist/Auditoría */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
              </div>
              <h3>SEO Técnico Puro</h3>
              <p>Corrección de errores de rastreo (Search Console), optimización del archivo robots.txt, sitemaps XML y marcado de datos estructurados (Schema).</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Servidor/Nube */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line></svg>
              </div>
              <h3>Optimización de Hosting</h3>
              <p>Análisis y mejora de la infraestructura del servidor. Migraciones a entornos más rápidos y configuración óptima de redes de distribución de contenido (CDN).</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Medalla/Google (Core Web Vitals) */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg>
              </div>
              <h3>Core Web Vitals</h3>
              <p>Garantizamos puntuaciones verdes en PageSpeed Insights aprobando los estándares LCP, FID y CLS exigidos por el nuevo algoritmo de Google.</p>
            </div>
          </div>

          {/* Banner de Llamada a la Acción (CTA) */}
          <div className="dev-cta-banner">
            <h3>¿Tu web tarda más de 3 segundos en cargar?</h3>
            <p>Estás perdiendo ventas cada día. Solicita una auditoría de rendimiento y hagamos que tu sitio sea ultra veloz.</p>
            <button 
              onClick={() => setIsModalOpen(true)} 
              className="dev-btn-primary" 
              style={{border: 'none', cursor: 'pointer', fontFamily: 'inherit'}}
            >
              Auditar mi Sitio Web
            </button>
          </div>
          
        </div>
      </section>

      {/* Sección + servicios */}
      <section id="abt-lnk" className="center-first">
        <div className="gp no-tpgp btm-spc130">
          <div className="container">
            <div className="skls-wrp2 ovrlp-60 text-center">
              <div className="skls-inr">
                <h2 itemProp="headline">
                  + servicios
                </h2>
              </div>
              <Services />
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
      <ChatBot />
      <Tooltip />
      <GlobalScripts />

      {/* Modal Anti-Spam */}
      <ContactModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        defaultService="Optimización Web" 
      />
    </>
  );
}

export default Optimizacion;